import { Action, createReducer, on } from '@ngrx/store';
import {
    getPickleCategories,
    getPickleCategoriesFailure,
    getPickleCategoriesSuccess,
    setPickleContractsCandidate,
    getPickleContractsByCandidateId,
    getPickleContractsByCandidateIdFailure,
    getPickleContractsByCandidateIdSuccess,
    getPickleSources,
    getPickleSourcesFailure,
    getPickleSourcesSuccess,
    getCandidatePickles,
    getCandidatePicklesFailure,
    getCandidatePicklesSuccess,
    submitPickle,
    submitPickleSuccess,
    submitPickleFailure,
    setSelectedContract,
    clearSelectedContract,
    setSelectedPickle,
    deletePickle,
    deletePickleSuccess,
    deletePickleFailure,
    clearSelectedPickle
} from 'src/app/travelxnew/store/actions/pickles.actions';

import { PicklesState } from '../state/pickles.state';

export const picklesStoreFeatureKey = 'pickles';

export const initialState: PicklesState = {
    sources: null,
    categories: null,
    contracts: [],
    error: undefined,
    candidatePickles: [],
    loading: false,
    submitPickleSuccessful: false,
    selectedContract: null,
    selectedPickle: null
};

const reducer = createReducer(
    initialState,

    on(getPickleCategories, (state) => ({
        ...state
    })),

    on(getPickleCategoriesSuccess, (state, action) => ({
        ...state,
        categories: action.categories
    })),

    on(getPickleCategoriesFailure, (state, action) => ({
        ...state,
        error: action.error
    })),

    on(getPickleSources, (state) => ({
        ...state
    })),

    on(getPickleSourcesSuccess, (state, action) => ({
        ...state,
        sources: action.sources
    })),

    on(getPickleSourcesFailure, (state, action) => ({
        ...state,
        error: action.error
    })),

    on(setPickleContractsCandidate, (state, action) => ({
        ...state,
        candidateId: action.candidateId
    })),

    on(getPickleContractsByCandidateId, (state, action) => ({
        ...state,
        candidateId: action.candidateId
    })),

    on(getPickleContractsByCandidateIdSuccess, (state, action) => ({
        ...state,
        contracts: action.contracts
    })),

    on(getPickleContractsByCandidateIdFailure, (state, action) => ({
        ...state,
        error: action.error
    })),

    on(getCandidatePickles, (state) => ({
        ...state,
        loading: true
    })),

    on(getCandidatePicklesSuccess, (state, action) => ({
        ...state,
        loading: false,
        candidatePickles: action.candidatePickles
    })),

    on(getCandidatePicklesFailure, (state, action) => ({
        ...state,
        candidatePickles: [],
        loading: false,
        error: action.error
    })),

    on(submitPickle, (state) => ({
        ...state,
        loading: true,
        submitPickleSuccessful: false
    })),

    on(submitPickleSuccess, (state) => ({
        ...state,
        loading: false,
        submitPickleSuccessful: true
    })),

    on(submitPickleFailure, (state, action) => ({
        ...state,
        loading: false,
        submitPickleSuccessful: false,
        error: action.error
    })),

    on(setSelectedContract, (state, action) => {
        const contract = state.contracts?.find((c) => c.contractId === action.contractId);
        return {
            ...state,
            selectedContract: contract ?? null
        };
    }),

    on(setSelectedPickle, (state, action) => ({
        ...state,
        selectedPickle: action.pickle
    })),

    on(clearSelectedContract, (state) => ({
        ...state,
        selectedContract: null
    })),

    on(clearSelectedPickle, (state) => ({
        ...state,
        selectedPickle: null
    })),

    on(deletePickle, (state) => ({
        ...state,
        loading: true,
        submitPickleSuccessful: false
    })),

    on(deletePickleSuccess, (state) => ({
        ...state,
        loading: false,
        submitPickleSuccessful: true
    })),

    on(deletePickleFailure, (state, action) => ({
        ...state,
        loading: false,
        submitPickleSuccessful: false,
        error: action.error
    }))
);

export function picklesReducer(state: PicklesState | undefined, action: Action) {
    return reducer(state, action);
}
